import React from "react";
import { useVeltClient } from "../context";
export function useHuddleUtils() {
    var _a = React.useState(), huddleElement = _a[0], setHuddleElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || huddleElement)
            return;
        var loadedHuddleElement = client.getHuddleElement();
        setHuddleElement(loadedHuddleElement);
    }, [client, setHuddleElement, huddleElement]);
    return huddleElement;
}
